module.exports = {"Archos":{"regex":"Archos.*GAMEPAD([2]?)","device":"console","model":"Gamepad $1"},"Microsoft":{"regex":"Xbox","device":"console","models":[{"regex":"Xbox One","model":"Xbox One"},{"regex":"Xbox","model":"Xbox 360"}]},"Nintendo":{"regex":"Nintendo (([3]?DS[i]?)|Wii[U]?|Switch)","device":"console","model":"$1"},"OUYA":{"regex":"OUYA","device":"console","model":"OUYA"},"Sega":{"regex":"Dreamcast","device":"console","model":"Dreamcast"},"Sony":{"regex":"PlayStation (3|4 Pro|4|Portable|Vita)","device":"console","model":"PlayStation $1"}}


//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/fixtures/regexes/device/consoles.json
// module id = 864
// module chunks = 113